import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { useEffect } from 'react';
import { useState } from 'react';
import { useHistory } from "react-router";
import { Loading } from "@merchstores/frontend/components/Loading"; 
import { shopifyImageResize } from "@merchstores/shared/components/Shopify";
import { generateCloudinaryMockupUrl } from "@merchstores/shared/components/Cloudinary";
import "./styles.scss";
import { ICollectionPageProductsProps } from ".";
import { shallowEqual, useSelector } from 'react-redux';
import { IMerchStore, IStoreState, Scalar } from '../../../reduxTypes';

export const CollectionPageProductTable = (props: ICollectionPageProductsProps) => {
  const history = useHistory();

  const { allProducts, filteredProducts, productFilterChosen, brandFilterChosen, priceFilterChosen, sortChosen } = props;

  const [products, setProducts] = useState([])
  const [currentPage, setCurrentPage] = useState(0);
  const [hasPreviousPage, setHasPreviousPage] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [footerText, setFooterText] = useState('');
  const [displayProducts, setDisplayProducts] = useState([]);
  const [artworkOptions, setArtworkOptions] = useState([]);
  const [isMobile, setIsMobile] = useState(false)
  const [isTablet, setIsTablet] = useState(false)
  const [imgSize, setImgSize] = useState('large')

  const merchstore: IMerchStore = useSelector((state: IStoreState) => state.merchstore, shallowEqual);

  useEffect(() => {
    const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
    const isTablet = window.matchMedia("only screen and (max-width: 1024px)").matches;
    if(isMobile) {
      setImgSize ('compact')
    } 
    setIsMobile(isMobile);
    setIsTablet(isTablet);
  }, [])

  useEffect(() => {
    setCurrentPage(0)
  },[sortChosen])

  useEffect(() => {
    if(productFilterChosen !== 'All' || brandFilterChosen !== 'All' || priceFilterChosen) {
      setProducts(filteredProducts)
    } else {
      setProducts(allProducts)
    }
    
  }, [productFilterChosen, allProducts, filteredProducts])

  useEffect(() => {
    let data = [];
    let count;
    isTablet ? count = 10 : count = 9;

    data = products.slice(currentPage * count, currentPage * count + count);
    if (products.slice((currentPage + 1) * count, (currentPage + 1) * count + count).length <= 0) {
      setHasNextPage(false);
    } else {
      setHasNextPage(true);
    }

    // Moves the user to first page after a filter is chosen
    if (currentPage !== 0 && data.length === 0) {
        setCurrentPage(0)
    }

    if (currentPage === 0) {
      setHasPreviousPage(false);
    } else {
      setHasPreviousPage(true);
    }

    setDisplayProducts(data);

    const startIndex = (currentPage * count) + 1;
    const endIndex = currentPage * count + data.length;
    setFooterText(`Showing ${data.length > 0 ? startIndex + " - " + endIndex : "0"} of ${products.length} items`);
    if (currentPage !== 0) {
      // Scroll to the pagination arrows
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, [currentPage, products])
   
  useEffect(() => {
    const merchstoreArtwork = merchstore.artworkOptions;
    if (merchstoreArtwork) {
      setArtworkOptions(merchstoreArtwork);
    }
  }, [merchstore])

  return (
    <>
    
    <div className="flex items-center justify-center lg:px-50">
      <div className="bg-white border-0 rounded-xl w-full lg:w-10/12 min-h-collection-table">
      {filteredProducts.length === 0 ?
      <div className="flex content-center items-center justify-center h-200">
        <div className="italic text-2xl">No Products</div>
      </div>
      :
        <div className="border-b-2 border-gray-100 rounded-t-xl flex flex-row w-full flex-wrap">
          {displayProducts && displayProducts.map((product: any, index: number) => {
            let productAvailable = false;
            const artworkOption = product.tags.find((t: Scalar) => t.value.includes("artwork_option="));
            const artworkIndex = artworkOption ? parseInt(artworkOption.value.split("=")[1]) : 1;
            const imgSrc = product.images[0]?.src
            const logoTag = product.tags.find((t: Scalar) => t.value.includes("LogoArea="));
            const formattedImage =
            imgSrc?.indexOf("shopify") > -1 && logoTag
              ? generateCloudinaryMockupUrl(480, 480, [logoTag.value], artworkOptions[artworkIndex - 1], imgSrc, "merchstores")
              : imgSrc;
            return (
            <div 
              key={product.id} 
              className={`px-4 xl:px-12 py-3 lg:py-8 flex items-center justify-between text-center flex-col w-6/12 lg:w-4/12 border-b-2 border-gray-100 ${index === 2 || index === 5 || index === 8 ? "" : "lg:border-r-2"} ${isTablet && index % 2 === 0 ? "border-r-2" : ""}`}>
              <img 
                onClick={() => history.push(`${product.handle}`)} 
                src={formattedImage} 
                alt={product.images[0]?.altText} 
                width="85%"
                className="cursor-pointer"/>
              <a 
                onClick={() => history.push(`${product.handle}`)} 
                className="store-link font-bold text-sm xl:text-lg py-3 cursor-pointer text-merch-dark-gray hover:underline">{product.title}</a>
              <div className="flex">
                { product.variants.map((variant: any) => {
                  variant.available ? productAvailable = true : null;
                })}
                  {productAvailable ?
                  <>
                    <p className="font-bold">{product.variants[0] && `$${product.variants[0].price}`}</p>
                    <p className="pl-2 line-through text-merch-text-disabled">{product.variants[0] && product.variants[0].compareAtPriceV2 && `$${product.variants[0].compareAtPriceV2.amount}`}</p>
                  </>
                  : <div className="flex justify-center items-center align-center bg-merch-text-disabled">
                      <p className="text-white font-bold text-9 lg:text-12 py-1.5 px-2.5">OUT OF STOCK</p>
                    </div>
                }
                </div>
              
            </div>)
          })}
        </div>
      }
          <div className="flex justify-between flex-row footer-container h-full pl-7 pr-7" >
            <div className="flex justify-start pagination-count italic">{footerText}</div>
            {(hasPreviousPage || hasNextPage) && <div className="pagination-arrows buttons-container group">
                <button className={`secondary ${!hasPreviousPage ? "disabled" : ""} left`} disabled={!hasPreviousPage ? true : false} onClick={() => setCurrentPage(currentPage - 1)}>
                    <MdKeyboardArrowLeft size="18px" />
                </button>
                <button className={`secondary ${!hasNextPage ? "disabled" : ""} right`} disabled={!hasNextPage ? true : false} onClick={() => setCurrentPage(currentPage + 1)}>
                    <MdKeyboardArrowRight size="18px" />
                </button>
            </div>}
          </div>
      
      </div>
    </div>
    </>
  )
}